// extracted by mini-css-extract-plugin
module.exports = {"text":"OpenButton_text__2_VTt","contained":"OpenButton_contained__39MxA","disabled":"OpenButton_disabled__1sYwL","error":"OpenButton_error__1HAM5"};